import { withChartLayout } from 'components/common';
import FallRiskAssessment from 'components/features/chart/admission-history/fall-risk-assessment/FallRiskAssessment';

const FallRiskAssessmentPage = withChartLayout('Fall Risk Assessment')(FallRiskAssessment);
export default FallRiskAssessmentPage;
